import { useEffect, useState } from "react";
import { authApi, formatINR } from "@/api";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi.get("/admin/orders").then(({ data }) => { setOrders(data); setLoading(false); });
  }, []);

  return (
    <div data-testid="admin-orders-page">
      <h1 className="heading-2 mb-2">Orders</h1>
      <p className="text-muted-foreground text-sm mb-8">{orders.length} orders</p>

      {loading ? (
        <div className="p-10 text-center text-muted-foreground">Loading…</div>
      ) : orders.length === 0 ? (
        <div className="bg-white border border-border p-10 text-center text-muted-foreground">No orders yet.</div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white border border-border" data-testid={`order-${o.id.slice(0, 8)}`}>
              <div className="flex flex-wrap items-center justify-between gap-2 px-5 py-3 border-b border-border bg-secondary">
                <div className="flex items-center gap-4">
                  <span className="label-caps">#{o.id.slice(0, 8).toUpperCase()}</span>
                  <span className="text-sm text-muted-foreground">{new Date(o.created_at).toLocaleString("en-IN")}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`label-caps px-2 py-1 text-white text-[10px] ${o.status === "paid" ? "bg-green-600" : "bg-[#E31837]"}`}>
                    {o.status === "paid" ? "Paid" : "Pending"}
                  </span>
                  <span className="font-bold">{formatINR(o.total)}</span>
                </div>
              </div>
              <div className="grid md:grid-cols-[1fr_260px] gap-6 p-5">
                <div className="space-y-2">
                  {o.items.map((i, idx) => (
                    <div key={idx} className="flex items-center gap-3 text-sm">
                      <img src={i.image} alt={i.name} className="w-10 h-10 object-cover border border-border" />
                      <div className="flex-1">
                        <p className="font-semibold">{i.name}</p>
                        {i.variant && <p className="text-xs text-muted-foreground">{i.variant}</p>}
                      </div>
                      <span className="text-muted-foreground">×{i.quantity}</span>
                      <span className="font-semibold w-20 text-right">{formatINR(i.price * i.quantity)}</span>
                    </div>
                  ))}
                </div>
                <div className="text-sm border-l border-border pl-6 md:block">
                  <p className="label-caps text-muted-foreground mb-2">Customer</p>
                  <p className="font-semibold">{o.customer.full_name}</p>
                  <p className="text-muted-foreground">{o.customer.email}</p>
                  <p className="text-muted-foreground">{o.customer.phone}</p>
                  <p className="text-muted-foreground mt-2">{o.customer.address}, {o.customer.city}, {o.customer.state} {o.customer.pincode}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
